import React from 'react';
import { ResourceStrings } from '../../../ResourceStrings';
import styled from 'styled-components/macro';
import { showIf } from '../../../utils/react';
import { App } from '../../../app';
import { CommentsList } from './Comments';
import Button from '../../shared/Button';
import { ChildPost, PostType, RootPost } from '../../../RootPost';
import HiddenTextInfo from '../Details/HiddenTextInfo';
import HtmlPreview from '../../shared/HtmlPreview';

export interface SolutionsProps {
    ticket: RootPost;
}

export default function Solutions({ ticket }: SolutionsProps): JSX.Element {
    const diditworkClick = (communityUrl): void => {
        App.telemetry.postBusinessEvent("diditwork-clicked", {
            feedbackItemUrl: communityUrl,
        });
        App.openSafe(communityUrl);
    }

    const solutionsAndWorkarounds: ChildPost[] = ticket.children.filter(child => (child.type === PostType.solution || child.type === PostType.workaround));
    return <Container>
        {solutionsAndWorkarounds.map((item: ChildPost, idx: number) => <Answer key={idx}>
            <div className="light-text">
                <span>{ResourceStrings.answerCreatedBy(item.author.name)}</span>
                <span>{App.ParseDateToLocalDate(item.createdDate as any)} </span>
            </div>

            <HiddenTextInfo post={item} currentUserId={ticket.currentUserId} />

            <HtmlPreview text={item.text} isPublic={item.isPublic} className="details" />

            <div style={showIf(item.canReactivate)} className="diditwork">{ResourceStrings.didSolutionWorkForYou()}
                <Button
                    size="compact"
                    onClick={() => diditworkClick(App.getNodeUrl(ticket.id, ticket.title, item.id, true))}
                    title={ResourceStrings.letUsKnowSolution()}
                    role="link"
                >
                    {ResourceStrings.letUsKnowSolution()} &gt;
                </Button>
            </div>
            <div className="light-text">{item.voteCount} {ResourceStrings.votes()}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {App.CountComments(item.children)} {ResourceStrings.comments()}</div>
            {item.children && item.children.length !== 0 && <CommentsList ticket={ticket} key={idx} comments={item.children} />}
        </Answer>)}
    </Container>
}

const Answer = styled.div`
    display: flex;
    flex-direction: column;

    .light-text {
        color: var(--color-on-surface-light);
        font-size: 1.4rem;
    }

    &>div {
        display: flex;

        &> * + * {
            margin-left: 3.5rem;
        }
    }

    && .details {
        display: block;
        word-break: break-all;

        p {
            margin-left: 0;
            margin-bottom: 1rem;
        }
    }

    &> * + * {
        margin-top: 1rem;
    }

    .diditwork {
        font-weight: bold;
        vertical-align: middle;
        line-height: 2.5rem;

        button {
            font-weight: normal;
            padding: 0.1rem 1rem;
            margin-left: 1rem;
        }
    }
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 2rem 4rem;
    background-color: var(--color-surface);

    ${Answer} + ${Answer} {
        margin-top: 2rem;
        border-top: solid 1px var(--color-on-surface-lighter);
        padding-top: 2rem;
    }

    ${Answer} .comment {
        margin-left: 5rem;
    }
`;
